import "./customers-list.scss";
import {UserDto} from "../../../users/model/User";
import {IComponentController, IHttpPromise, ILogService, IPromise, IQService, ITimeoutService} from "angular";
import {CustomerFilter} from "../../model/CustomerFilter";
import {Customer} from "../../model/Customer";
import {Sorting, SortingDirection, SortingDirectionFieldNames} from "../../../dynamic-ordering/components/sorting";
import {Page} from "../../../utils/models/Page";
import {ToastNotificationService} from "../../../utils/ToastNotificationService";
import {
    CUSTOMER_DETAILS_SERVICE_NAME,
    CustomerFilterParametersServiceName,
    CustomerServiceName,
    ToastNotificationServiceName,
    UserServiceName
} from "../../../utils/names/serviceNames";
import {CustomerService} from "../../../customer_service/service/CustomerService";
import {UserService} from "../../../users_service/service/user.service";
import {SendgridContactListDialogComponent} from "../sendgrid-contact-dialog/SendgridContactList.dialog.component";
import {UserView} from "../../../users/model/UserFilter";
import {ReportLog} from "../../../manual_import/model/ReportLog";
import {CustomerDetailsService} from "../../../customer_service/service/CustomerDetailService";
import {PrincipalUtil} from "../../../utils/PrincipalUtil";
import {UserGranredAuthorityName} from "../../../router/const/AllPermitions";
import {
    PermanentlyDeleteCustomerDialog
} from "../permanently-delete-customer-dialog/permanently-delete-customer.dialog.component";
import {SendGridContactListOptions} from "../../model/SendGridContactListOptions";
import {CustomerCsvExportDescriptor} from "../../model/CustomerCsvExportDescriptor";
import {LoanAmountModal} from "modules/customers/component/filters/loan-amount/loan-amount-modal";
import {InterestRateModal} from "modules/customers/component/filters/interest-rate/interest-rate-modal";
import {EquityModal} from "modules/customers/component/filters/equity-filter/equity-modal";
import {CustomerFilterParametersService} from "modules/filter_components/service/CustomerFilterParametersService";


interface CustomerControllerScope extends ng.IScope {
    exportCustomersCSV: (type: string) => void;
    showLoader: boolean,
    fetchAgents: (query: string) => IPromise<UserDto[]>,
    fetchCode: (query: string) => IPromise<UserDto[]>,
    createSendgridContactGroup: ($event: MouseEvent) => void;
    updateCustomersData: () => void;
    reloadCustomerData: () => void;
    loadFieldDescriptions: () => void;
    exportDescriptions: CustomerCsvExportDescriptor[];
    showFilter: boolean;
    showCsvExport: boolean;
    getTableCheckboxTheme: () => string;
    allCustomersSelected: boolean;
    filter: CustomerFilter;
    selectedCustomers: Customer[];
    orderFunnelStatus: Sorting,
    orderFundedDate: Sorting,
    orderLoanOfficer: Sorting,
    orderBranch: Sorting
    customersPage: Page<any>;
    customersPagePromise: IHttpPromise<any>;
    checkForSubmit: (event: KeyboardEvent) => void;
    showSelectedCustomersMenu: boolean;
    toggleFilteringMenu: () => void;
    openCustomerMenu: ($mdMenu: angular.material.IMenuService, ev: MouseEvent) => void
    setSelectedBranchesIds: (selectedBranchesIds: number[]) => void;
    permanentlyDeleteCustomer: (customer: Customer) => void;
    deleteCustomer: (customer: Customer) => void;
    restoreCustomer: (customer: Customer) => void;
    showCustomerMenuOptions: ShowCustomerMenuOptions;
    propertyStates: string[];
    mailingStates: string[];
    setInterestRate: (range: { min: number; max: number }) => void;
    openLoanModal: ($event: MouseEvent) => void;
    openInterestRateModal: ($event: MouseEvent) => void;
    openEquityModal: ($event: MouseEvent) => void;
    hasFilters: boolean;
}

interface ShowCustomerMenuOptions {
    showMenu?: boolean,
    showDeletePermanently?: boolean,
    showDeleteTemporarily?: boolean
}


const DEFAULT_PAGE_SIZE = 10;

export class CustomersList implements IComponentController {
    public static instance = {
        controller: [
            '$scope',
            '$location',
            'LoaderStatusValue',
            CustomerServiceName,
            CUSTOMER_DETAILS_SERVICE_NAME,
            UserServiceName,
            ToastNotificationServiceName,
            CustomerFilterParametersServiceName,
            '$log',
            '$mdDialog',
            '$timeout',
            '$q',
            CustomersList
        ],
        template: require('./customers-list.html'),
        bindings: {
            log: '<',
            onProfileClick: '<'
        }
    };

    private $scope: CustomerControllerScope;
    private customerService: CustomerService;
    private customerDetailService: CustomerDetailsService;
    private notificationService: ToastNotificationService;
    private parametersService: CustomerFilterParametersService;
    private $location: ng.ILocationService;
    private $mdDialog: angular.material.IDialogService;
    private $timeout: ITimeoutService;
    private originatorMenuEvent: MouseEvent;
    private log?: ReportLog;
    private onProfileClick?: (customerId: number) => void;
    private $q?: IQService;
    private rangeOptions?: RangeOptionsDto;


    constructor($scope: CustomerControllerScope,
                $location: ng.ILocationService,
                LoaderService,
                customerService: CustomerService,
                customerDetailService: CustomerDetailsService,
                employeeService: UserService,
                notificationService: ToastNotificationService,
                parametersService: CustomerFilterParametersService,
                $log: ILogService,
                $mdDialog: angular.material.IDialogService,
                $timeout: ITimeoutService,
                $q: IQService) {
        this.$location = $location;
        this.notificationService = notificationService;
        this.parametersService = parametersService;
        this.customerService = customerService;
        this.customerDetailService = customerDetailService;
        this.$mdDialog = $mdDialog;
        this.$timeout = $timeout;
        this.$q = $q;
        this.$scope = Object.assign($scope, {
            showLoader: false,
            showFilter: false,
            showCsvExport: false,
            openCustomerMenu: this.openCustomerMenu,
            permanentlyDeleteCustomer: this.permanentlyDeleteCustomer,
            deleteCustomer: this.deleteCustomer,
            restoreCustomer: this.restoreCustomer,
            orderFunnelStatus: new Sorting(SortingDirection.NONE, SortingDirectionFieldNames.FUNNEL_STATUS),
            orderFundedDate: new Sorting(SortingDirection.NONE, SortingDirectionFieldNames.FUNDED_DATE),
            orderLoanOfficer: new Sorting(SortingDirection.NONE, SortingDirectionFieldNames.LOAN_OFFICER),
            orderBranch: new Sorting(SortingDirection.NONE, SortingDirectionFieldNames.BRANCH),
            filter: {
                selectedBranchesIds: [],
                selectedBrandsNames: [],
                includeDeleted: false,
                includeActivatedEmployeeOnly: false,
                nameFilter: '',
                employeeIds: [],
                orderBy: [Sorting],
                selectedProductCode: [],
            },
            customersPage: {
                number: 1,
                size: DEFAULT_PAGE_SIZE
            },
            selectedCustomers: [],
            checkForSubmit: this.checkForSubmit,
            reloadCustomerData: this.reloadCustomerData,
            updateCustomersData: this.updateCustomersData,
            setEmployeeIds: this.setEmployeeIds,
            setProductCode: this.setProductCode,
            navigateTo: this.navigateTo,
            toggleFilteringMenu: this.toggleFilteringMenu,
            setSelectedBranchesIds: this.setSelectedBranchesIds,
            openLoanModal: this.openLoanAmountDialog,
            openEquityModal: this.openEquityDialog,
            openInterestRateModal: this.openInterestRateDialog,

        });

        $scope.hasFilters = false;
        $scope.$watchCollection('filter', () => {
            const f = $scope.filter;
            $scope.hasFilters =
                !!f.nameFilter
                || (f.employeeIds           && f.employeeIds.length > 0)
                || (f.selectedBranchesIds   && f.selectedBranchesIds.length > 0)
                || (f.selectedBrandsNames   && f.selectedBrandsNames.length > 0)
                || f.minLoanAmount != null || f.maxLoanAmount != null
                || f.minRate      != null || f.maxRate      != null
                || f.minEquity    != null || f.maxEquity    != null
                || f.includeDeleted
                || f.includeActivatedEmployeeOnly
                || !!f.loanPurpose
                || !!f.loanType
                || (f.statuses             && f.statuses.length > 0)
                || (!!f.propertyStates && f.propertyStates.length > 0)
                || (!!f.mailingStates && f.mailingStates.length > 0)
                || !!f.fundedDateStartingFrom
                || !!f.fundedDateUntil
                || (f.selectedProductCode && f.selectedProductCode.length > 0);
        });
        $scope.fetchAgents = (query: string): IPromise<UserDto[]> => {
            return employeeService.queryEmployee({
                view: UserView.AUTOCOMPLETE,
                userIds: [],
                branchesIds: this.$scope.filter.selectedBranchesIds,
                showDeleted: false,
                showDisabled: true,
                query: query
            }).then(resp => {
                if (resp.status === 200) {
                    return resp.data;
                } else {
                    this.notifyFailedToFetchAccount(notificationService);
                }
            });
        };
        $scope.fetchCode = (query: string): IPromise<UserDto[]> => {
            return customerDetailService.queryEmployee(query).then(resp => {
                if (resp.status === 200) {
                    return resp.data;
                } else {
                    this.notifyFailedToFetchCode(notificationService);
                }
            });
        };
        this.$scope.filter.orderBy = [
            this.$scope.orderBranch,
            this.$scope.orderFundedDate,
            this.$scope.orderFunnelStatus,
            this.$scope.orderLoanOfficer
        ];
        $scope.exportCustomersCSV = this.exportCustomersCSV;
        $scope.loadFieldDescriptions = this.loadFieldDescriptions;
        $scope.$watch('selectedCustomers.length', (newValue: number) => {
            $scope.showSelectedCustomersMenu = newValue > 0;
            $scope.allCustomersSelected = newValue === $scope.customersPage.size;
        });
        $scope.createSendgridContactGroup = this.createSendgridContactGroup;
        LoaderService.off();
    }

    $onInit(): void {
        this.$scope.filter.log = this.log;
        this.loadStatesOptions();
        this.searchForCustomers(
            this.$scope.customersPage.size,
            this.$scope.customersPage.number,
            this.$scope.filter);
        if (this.onProfileClick == null) {
            this.onProfileClick = (customerId => {/* do nothing */
            });
        }
        this.initShowCustomerMenuOptions();
        this.initShowCsvExport();
    }

    private initShowCustomerMenuOptions() {
        this.$scope.showCustomerMenuOptions = {
            showMenu: false,
            showDeleteTemporarily: false,
            showDeletePermanently: false
        };
        this.$q.all({
            TEMPORARY_DELETE_CUSTOMER: PrincipalUtil.hasAuthorityPromise(UserGranredAuthorityName.TEMPORARY_DELETE_CUSTOMER),
            PERMANENTLY_DELETE_CUSTOMER: PrincipalUtil.hasAuthorityPromise(UserGranredAuthorityName.PERMANENTLY_DELETE_CUSTOMER)
        }).then(resolvedHash => {
            this.$scope.showCustomerMenuOptions = {
                showDeleteTemporarily: resolvedHash.TEMPORARY_DELETE_CUSTOMER,
                showDeletePermanently: resolvedHash.PERMANENTLY_DELETE_CUSTOMER,

                showMenu: resolvedHash.PERMANENTLY_DELETE_CUSTOMER || resolvedHash.TEMPORARY_DELETE_CUSTOMER
            }
        })

    }

    private loadRangeOptions(): void {
        this.parametersService
            .findFilteredCustomersAmountOptions(this.$scope.filter)
            .then(r => this.rangeOptions = r.data)
            .catch(() => console.warn('range-options load failed'));
    }

    private loadStatesOptions(): void {
        this.parametersService
            .findStatesOptions()
            .then(resp => {
                this.$scope.mailingStates = resp.data
                this.$scope.propertyStates = resp.data
                this.$scope.$applyAsync();
            })
            .catch(() => console.warn('range-options load failed'));
    }

    private initShowCsvExport() {
        PrincipalUtil.hasAuthorityPromise(UserGranredAuthorityName.CSV_EXPORT)
            .then(toggle => this.$scope.showCsvExport = toggle);
    }

    private notifyFailedToFetchAccount(notificationService: ToastNotificationService) {
        notificationService.generateErrorMessage('Failed to fetch Users');
    }

    private notifyFailedToFetchCode(notificationService: ToastNotificationService) {
        notificationService.generateErrorMessage('Failed to fetch code');
    }

    getOrderByParams = (): Sorting[] => {
        let $scope = this.$scope;
        let orderBy: Sorting[] = [
            $scope.orderBranch,
            $scope.orderFundedDate,
            $scope.orderFunnelStatus, $scope.orderLoanOfficer
        ];
        return Object.values(orderBy)
            .sort((o1, o2) => (o2.lastUpdated.getTime() - o1.lastUpdated.getTime()));
    };

    createSendgridContactGroup = ($event: MouseEvent) => {
        this.$mdDialog.show(SendgridContactListDialogComponent.instance($event))
            .then((sendGridOptions: SendGridContactListOptions) => {
                this.$scope.customersPagePromise = <IPromise<any>>this.getCreateSendgridGroupPromise(sendGridOptions);
            })
    };


    private getCreateSendgridGroupPromise = (sendGridOptions: SendGridContactListOptions): IPromise<void> => {
        if (this.$scope.allCustomersSelected) {
            return this.createSendgridGroupFromSelectedFilter(sendGridOptions);
        } else {
            return this.createSendgridGroupFromSelectedCustomersIds(sendGridOptions);
        }
    };

    openCustomerMenu = ($mdMenu: angular.material.IMenuService,
                        ev: MouseEvent) => {
        this.originatorMenuEvent = ev;
        $mdMenu.open(ev);
    };

    toggleFilteringMenu = () => {
        this.$scope.showFilter = true;

        if (!this.rangeOptions) {
            this.loadRangeOptions();
        }

        this.refreshSlider();
    };

    refreshSlider = () => {
        this.$timeout(() => {
            this.$scope.$broadcast('rzSliderForceRender')
        })
    };

    private createSendgridGroupFromSelectedFilter = (sendGridOptions: SendGridContactListOptions): IPromise<void> => {
        let filter = this.$scope.filter;
        return this.customerService.createSendgridContactsListFromFilteredCustomers(sendGridOptions, filter)
            .then(this.handleNewSendgridGroupSuccess, this.handleNewSendgridGroupFailure);
    };


    private createSendgridGroupFromSelectedCustomersIds = (sendGridOptions: SendGridContactListOptions): IPromise<void> => {
        let selectedCustomersIds = this.$scope.selectedCustomers.map(c => c.id);
        return this.customerService.createSendgridContactsListFromContactIds(sendGridOptions, selectedCustomersIds)
            .then(this.handleNewSendgridGroupSuccess, this.handleNewSendgridGroupFailure);
    };

    private handleNewSendgridGroupSuccess = resp => {
        this.$scope.showLoader = false;
        this.notificationService.generateSuccessMessage("Successfully created sendgrid contact group!");
    };

    private handleNewSendgridGroupFailure = err => {
        this.$scope.showLoader = false;
        this.notificationService.generateErrorMessage("Failed to create sendgrid contact group!");
    };

    private navigateTo = (customerId) => {
        this.onProfileClick(customerId);
        this.$location.path(`/contact_profile/${customerId}`);
    };

    private setSelectedBranchesIds = (selectedBranchesIds: string[]) => {
        this.$scope.filter.selectedBranchesIds = selectedBranchesIds;
    };

    private setEmployeeIds = (newValue: number[]) => {
        this.$scope.filter.employeeIds = newValue;
    };

    private setProductCode = (newValue: string[]) => {
        this.$scope.filter.selectedProductCode = newValue;
    };

    private permanentlyDeleteCustomer = (customer: Customer) => {
        this.$mdDialog.show(PermanentlyDeleteCustomerDialog.instance(customer))
            .then(
                () => this.handleDeleteCustomerResponse(customer),
                () => this.notificationService.generateErrorMessage('Contact wasn\'t deleted.')
            );
    };

    private deleteCustomer = (customer: Customer) => {
        return this.customerService.deleteCustomer(customer.id)
            .then(
                () => this.handleDeleteCustomerResponse(customer),
                () => this.notificationService.generateErrorMessage('Contact wasn\'t deleted.')
            );
    };


    private restoreCustomer = (customer: Customer) => {
        return this.customerDetailService.restoreCustomer(customer.id)
            .then(
                () => this.handleRestoreCustomerResponse(customer),
            )
    };

    private handleDeleteCustomerResponse(customer: Customer) {
        customer.deleted = true;
        this.notificationService.generateSuccessMessage('Contact was deleted.');
    };

    private handleRestoreCustomerResponse(customer: Customer) {
        customer.deleted = false;
        this.notificationService.generateSuccessMessage('Contact was restored.');
    };

    private reloadCustomerData = () => {
        this.$scope.customersPage.number = 1;
        this.updateCustomersData();
    };

    private exportCustomersCSV = (type: string) => {
        this.$scope.customersPagePromise = <IPromise<any>>this.fetchCustomersExport(type).then(resp => {
            require("downloadjs")(resp.data, 'test.csv', 'text/csv');
        });
    };

    private fetchCustomersExport = (type: string): IHttpPromise<any> => {
        if (this.$scope.allCustomersSelected) {
            return this.customerService.downloadCsvExport(this.$scope.filter, type);
        } else {
            let selectedIds = this.$scope.selectedCustomers.map(c => c.id);
            return this.customerService.downloadCsvExportForCustomers(selectedIds, type);
        }
    };

    private updateCustomersData = () => {
        this.$scope.selectedCustomers = [];
        return this.searchForCustomers(this.$scope.customersPage.size, this.$scope.customersPage.number, this.$scope.filter);
    };

    private searchForCustomers = (amount: number, page: number, filter: CustomerFilter) => {
        const customerFilter = this.sanitizeFilter(filter);
        this.$scope.customersPagePromise = this.customerService.findFilteredCustomers(amount, page, customerFilter)
            .then(resp => {
                let customersPage = resp.data;
                if (resp.status === 200) {
                    customersPage.number += 1;
                    this.$scope.customersPage = customersPage;
                } else {
                    console.log(customersPage);
                }
                return resp;
            });
    };

    private checkForSubmit = (event) => {
        if (event.which === 13) {
            this.reloadCustomerData();
        }
    }

    private loadFieldDescriptions = () => {
        this.customerService.loadFieldDescriptions().then(resp => {
            this.$scope.exportDescriptions = resp.data;
        });
    }

    openLoanAmountDialog = (ev: MouseEvent) => {
        this.$mdDialog
            .show(LoanAmountModal.instance(ev, this.$scope.filter, this.rangeOptions))
            .then((result: CustomerFilter) => {
                Object.assign(this.$scope.filter, result);
            })
            .catch(() => {
            });
    };

    openInterestRateDialog = (ev: MouseEvent) => {
        this.$mdDialog.show(
            InterestRateModal.instance(ev, this.$scope.filter, this.rangeOptions)
        ).then((res: CustomerFilter) => {
            Object.assign(this.$scope.filter, res);
        });
    }

    openEquityDialog = (ev: MouseEvent) =>
        this.$mdDialog.show(
            EquityModal.instance(ev, this.$scope.filter, this.rangeOptions)
        ).then((res: CustomerFilter) => {
            Object.assign(this.$scope.filter, res);
        });

    private sanitizeFilter = (src: CustomerFilter): CustomerFilter => {
        const f = {...src};
        if (f.minLoanAmount == null && f.maxLoanAmount == null) {
            delete f.minLoanAmount;
            delete f.maxLoanAmount;
        }
        if (f.minRate == null && f.maxRate == null) {
            delete f.minRate;
            delete f.maxRate;
        }
        if (f.minEquity == null && f.maxEquity == null) {
            delete f.minEquity;
            delete f.maxEquity;
        }
        return f
    }
}
